import PricingCard from '@Web/Src/UI/Pricing/Components/PricingCard';
import LinkSection from '@Web/Src/UI/LinkSection';
import { PRICING } from '@Web/Src/constants.js';
import { router } from '@inertiajs/react';
import { useState } from 'react';

const Pricing = ({ fromPricingPage = false }) => {
    const handlePlans = () => {
        if (fromPricingPage) {
            const element = document.getElementById('pricing-table');
            element && element.scrollIntoView({ behavior: 'smooth' });
        } else {
            router.visit(route('web.pages.pricing'));
        }
    };

    const [yearlyOn, setYearlyOn] = useState(true);
    const handleToggle = () => {
        setYearlyOn(!yearlyOn);
    };

    return (
        <div className={'w-full'}>
            <div
                onClick={() => {
                    handleToggle();
                }}
                className={
                    'border-grey small:max-w-fit mx-auto mt-10 flex h-12 w-full max-w-[308px] cursor-pointer items-center justify-center rounded-[56px] border border-solid p-1 text-center font-semibold'
                }
            >
                <div
                    className={`flex h-full items-center rounded-3xl px-6 ${yearlyOn ? 'text-dark' : 'text-light bg-dark'}`}
                >
                    {__('Monthly')}
                </div>
                <div
                    className={`flex h-full items-center gap-2.5 rounded-3xl px-6 ${yearlyOn ? 'bg-dark' : ''}`}
                >
                    <div className={`${yearlyOn ? 'text-light' : 'text-dark'}`}>
                        {__('Yearly')}
                    </div>
                    <div
                        className={`flex w-[86px] items-center justify-center whitespace-nowrap rounded-3xl bg-[#FFEECA] px-1 pt-0.5 !text-sm ${yearlyOn ? 'text-dark' : 'text-[#875B00]'}`}
                    >
                        {__('SAVE 20%')}
                    </div>
                </div>
            </div>

            <div
                className={
                    'pricing-cards-wrapper mt-10 flex flex-wrap items-stretch justify-center gap-6 px-6 py-6'
                }
            >
                {PRICING.map((item, index) => (
                    <div
                        className={
                            'large:max-w-[45%] small:max-w-[100%] flex h-auto w-full max-w-[250px]'
                        }
                        key={index}
                    >
                        <PricingCard plan={item} yearlyOn={yearlyOn} />
                    </div>
                ))}
            </div>
            <LinkSection handleClick={handlePlans} link={__('Compare all plans')} />
        </div>
    );
};

export default Pricing;
